import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=53aa2804&scoped=true"
import script from "./Thread.vue?vue&type=script&lang=ts"
export * from "./Thread.vue?vue&type=script&lang=ts"
import style0 from "./Thread.vue?vue&type=style&index=0&id=53aa2804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aa2804",
  null
  
)

export default component.exports